import {Serializers} from '../../interfaces/serializer';
import {DataSetDimension} from '../../interfaces/dimensions';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';

export const DATASET_DIMENSIONS_STATE_NAME = 'datasetDimensions';

export interface DataSetDimensionsState {
  serialized: {
    all: Serializers<DataSetDimension>,
    normalized: Serializers<DataSetDimension>,
    source: Serializers<DataSetDimension>
  };
  componentObjects: {
    all: DimensionComponentObjects,
    normalized: DimensionComponentObjects,
    source: DimensionComponentObjects
  };
  included: Serializers<any>;
  loading: boolean;
  loaded: boolean;
}
